import type { IconData } from '@stacksjs/iconify-core'

export const natureWater: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 0S1 3.5 1 9a7 7 0 1 0 14 0c0-5.5-7-9-7-9m5 9a5 5 0 0 1-5 5v-1.5A3.5 3.5 0 0 0 11.5 9z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureWater
